import { useEffect, useState } from "react";

export default function KpiCounter({ value })
{
    const [displayValue, setDisplayValue] = useState(0);

    useEffect(() =>
    {
        let current = displayValue;

        const step =
            value > current ? 1 : -1;

        const timer =
            setInterval(() =>
            {
                current += step;
				
				if(current < 0){
					current = 0;
				}

                setDisplayValue(current);

                if(current === value)
                {
                    clearInterval(timer);
                }

            }, 30);

        return () => clearInterval(timer);

    }, [value]);

    return displayValue;
}